import { FC, ReactNode } from 'react';

import classes from './CardItem.module.scss';

interface CardItemProps {
  children: ReactNode;
}

const CardItem: FC<CardItemProps> = ({ children }) => {
  return <div className={classes.cardItem}>{children}</div>;
};

export default CardItem;
